import {RewardedInfo} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SpaceTr, Tr, TrSpace} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class RewardedAdvPanel extends Phaser.GameObjects.Container {

    public static HEIGHT: number = 144;

    constructor(scene: Phaser.Scene, x: number, y: number, ri: RewardedInfo, callback: () => void) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.width = CU.CANVAS_WIDTH;
        this.height = RewardedAdvPanel.HEIGHT;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, RewardedAdvPanel.HEIGHT);

        const image = SpriteUtils.addImage(this.scene, 60, RewardedAdvPanel.HEIGHT / 2 - 4, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_GEMS_0, 0.8).setOrigin(0.5, 0.5);

        let ttlText = Tr('gn.gems');
        const titleLight = SpriteUtils.addImage(this.scene, 140 - ttlText.length * 5, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT).setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 360 / 14 * ttlText.length, 65);

        let titleText = TextUtils.addTextAdvanced(scene, ttlText, 125, 35,
            '#e3ce93', 20, 'normal', 350, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#000000', 1);

        let countText = TextUtils.addTextAdvanced(scene, TrSpace('w.a.g') + String(ri.reward) + SpaceTr('gems.mul.gen').toUpperCase(), 125,
            55, '#9a9a98', 12, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);

        let commText = TextUtils.addTextAdvanced(scene, String(ri.todayWatchTimes) + '/' + String(ri.maxWatchTimes) + SpaceTr('ws.tdy'), 125,
            115, '#848484', 12, 'normal', 320, 'left', 1, Fonts.MYRIADPRO_REGULAR);

        countText.setOrigin(0, 0).setStroke('#000000', 1);

        let buyButton = SpriteUtils.scale(new SquareButton(this.scene, 530, RewardedAdvPanel.HEIGHT / 2 - 4, -10, Keys.UI_ART_BROWN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.PLAY_REWARDED, '', false, 84, 84, 0), 0.7);

        buyButton.setCallback(() => {
            callback();
        });

        let buyPriceText = TextUtils.addText(scene,
            Tr('wtch'), 530, RewardedAdvPanel.HEIGHT / 2 + 28, '#ffffff', 10, 'bold', 200);

        const separator = SpriteUtils.addSprite(this.scene!, 0, RewardedAdvPanel.HEIGHT, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([back, image, titleLight, titleText, countText, commText, buyButton, buyPriceText, separator]);
    }

}
